//core modules
import React, {useEffect, useState} from "react";

//External modules
import {Col} from "reactstrap";
import cx from "classnames";
import Select from "react-select";

//custom modules
import {
    currencyFormatter,
    getOrganizationInfo,
    handleErrorResponse,
    updateOrganizationInfo,
    dateDiff, setSessionValue,
    showToast,
    getSessionValue
} from "../../Common/Appcommon";
import {useStepsContext} from "./context/stepsContext";
import requestApi from "../../services/requestApi.service";
import razorPayDarkTheme from "../../assets/utils/images/razorpay-dark.png"

const SubscriptionBilling = () => {

    const {
        currentStep,
        setCurrentStep,
        paymentInfo,
        subTotal,
        total,
        setTotal,
        tax,
        setTax,
        gatewayCharges,
        setGateWayCharges,
        TDS,
        setTDS,
        requiredUsers,
        pricePerUser,
        plan,
        prevPaymentDeduction,
        isEarlyUpdate,
        proRataCharges,
        setProRataCharges,
        netAmount,
        setNetAmount,
        usageType,
        isRecurringPayment,
        setIsRecurringPayment,
        updateUsageType,
        setShowLoader,
        tdsPercentage,
        setTDSPercentage,
        subscriptiontype,
        maxSubAmount,
        addOnsRecord,
        callRec,
        whatsappApi,
        cloudTele,
        licenseEndDate,
        addOnsTotal,
        addOnsRecordVal,
        isAddonEnbled,
        planMonths,
        paidUsers,
        isEMandate, 
        setIsEMandate,
        paymentMethod,
        setPaymentMethod,
        maxAmount,
        showSubscription,
        showOnline,
        showEmandate,
        subscriptionType,
        addRequiredUsers,
        paymentsMethods,
        paymentDetails
    } = useStepsContext();
    const gstNoRef = React.useRef(null);

    const [billingInfo, setBillingInfo] = useState({});
    const [showGST,setShowGST] = useState(false);
    const [showGatewayCharges, setShowGatewayCharges] = useState(false);
    const [showTDS, setShowTDS] = useState(false);
    const [CreditCardPayment, setCreditCardPayment] = useState(false);
    const [prorataDeduction, setProrataDeduction] = useState(0);
    const [licenseInfo, setLiceinseInfo] = useState([]);
    const [formError, setFormError] = useState({});

    const orgFormName = process.env.REACT_APP_ORGANIZATION_FORMNAME;

    useEffect(()=>{
        (async ()=>{
            await getLicenseInfo();
            await getBillingInfo();
            await updatePaymentSummary(true);
        })();
    },[]);

    useEffect(()=>{
        updatePaymentSummary(true);
    },[licenseInfo]);

    useEffect(()=>{
        updatePaymentSummary(false);
    },[usageType]);


    const updatePaymentSummary = async (updateRecurringType=false) => {

        let taxAmount = 0;
        let totalAmount = 0;
        let prorataAmount = 0;
        let gatewaycharges = 0;
        let tdsCharges = 0;
        let actualTDSPercentage = 0;
        let licensedDays = 30;
        let prorataDeductionAmount = 0;
        let showtds = false;
        let showGwCharges = false;
        let actualSubTotal = subTotal - prevPaymentDeduction;
        let actualRecurringType = false;

        //below variables will be used for future subscription calculation
        let acutalNetAmount = subTotal;
        let netGateWayCharges = 0;
        let netTDSCharges = 0;
        let netTaxAmount = 0;
        let netTotalAmount = 0;

        if(paymentInfo && paymentInfo.length > 0){
            if(subscriptionType !== undefined && subscriptionType !== null && updateRecurringType){
                /*
                * Razorpay allows maximum of Rs.15,000 only for recurring subscription.
                * so we only show recurring option if the total amount is less than Rs.12,000 since we append tax amount also with this total.
                * */
                let setNextmethod = '';
                const subAmountTax = (subTotal * 18) / 100;
                if(showEmandate && subscriptionType === "Recurring" && paymentInfo[13] === "Subscription" && subTotal < 15000){
                    let e_payments = paymentsMethods["emandate"];
                    let max_upi_amount = 100000;
                    for(let i = 0; i < e_payments.length; i++){
                        if(e_payments[i]["name"] === "upi"){
                            max_upi_amount = e_payments[i]["max_amount"];
                        }
                    }
                    if(paymentMethod === ""){
                        setPaymentMethod((subTotal + subAmountTax) < max_upi_amount ? "upi" : "debitcard")  
                    }else{
                        if(paymentsMethods["emandate"] !== undefined && paymentsMethods["emandate"][1]!== undefined && paymentsMethods["emandate"][1].name !== undefined && paymentsMethods["emandate"][1].name !== null){
                            setNextmethod = paymentsMethods["emandate"][1].name;
                        }
                        setPaymentMethod(paymentMethod === "upi" && (subTotal + subAmountTax) < max_upi_amount ? "upi" : setNextmethod);                       
                    }
                    setIsEMandate(true);
                }else{
                    setIsEMandate(false);
                    setIsRecurringPayment(false);
                }
            }else{
                actualRecurringType = isRecurringPayment;
            }

            const curUsageType = updateUsageType(actualRecurringType);

            //reset value to 0 when subscription cancelled and payment type moved to manual.
            if(curUsageType === 7){
                actualSubTotal = 0;
                acutalNetAmount = 0;
            }

            let isSubscriptionDecrease = (curUsageType === 4);
            let isAddonsDecrease = (curUsageType === 11);
            // prorata calculation don't apply to addons records counts
            let checkIsAddRecordOnly = (actualSubTotal - addOnsRecordVal === 0);
            //calculate the prorata charges.
            let notInUseageTypes = usageType !== 8 && usageType !== 9 && usageType !== 13;
            if(isEarlyUpdate && actualSubTotal > 0 && !isAddonsDecrease && !isSubscriptionDecrease && paymentInfo[5] !== undefined && paymentInfo[5] !== "" && notInUseageTypes && !checkIsAddRecordOnly && addRequiredUsers !== ""){
                const proRataDays = dateDiff(new Date(),new Date(licenseInfo[8])) === 0 ? 1 : dateDiff(new Date(),new Date(licenseInfo[8]));
                /* if(licenseInfo[9] !== undefined && licenseInfo[9] !== ""){
                    licensedDays = parseInt(licenseInfo[9]);
                } */
                const dailyRate = pricePerUser / licensedDays;
                prorataAmount = parseFloat(dailyRate * proRataDays);
                prorataAmount = prorataAmount * addRequiredUsers;
                prorataDeductionAmount = actualSubTotal - prorataAmount;
                actualSubTotal = prorataAmount;
            }

            let currentMode = paymentDetails?.items?.modeofpayment;
            if(subscriptiontype === "upgrade"){
                const proRataDays = dateDiff(new Date(),new Date(licenseInfo[8])) === 0 ? 1 : dateDiff(new Date(),new Date(licenseInfo[8]));
                let index = 0;
                let months = 1;
                let number_of_user = getSessionValue("licenseInfo_number_of_user");
                if(currentMode === 'Quarterly') {
                    index = 1;
                    months = 3;
                }else if(currentMode === "Half Yearly") {
                    index = 2;
                    months = 6;
                }else if(currentMode === "Yearly") {
                    index = 3;
                    months = 12;
                };
                let prev_plan_cost = parseFloat(paymentInfo[index]);
                prev_plan_cost = prev_plan_cost * months;
                prev_plan_cost = prev_plan_cost * number_of_user;
                prorataAmount = ((actualSubTotal - prev_plan_cost) / (planMonths * 30)) * proRataDays;
                prorataDeductionAmount = actualSubTotal - prorataAmount;
                actualSubTotal = prorataAmount;
            }
            //check whether Gateway charges enabled for customer.
            if(paymentInfo[9] !== undefined && paymentInfo[9] === 'Yes'){
                if(actualSubTotal > 0){
                    gatewaycharges = parseFloat((actualSubTotal * 1.95) / 100);
                }
                if(acutalNetAmount > 0){
                    netGateWayCharges = parseFloat((acutalNetAmount * 1.95) / 100);
                }
                showGwCharges = true;
            }

            //Get TDS percentage from
            if(paymentInfo[10] !== undefined && paymentInfo[10] === 'Yes'){
                if(paymentInfo[19] !== undefined && parseFloat(paymentInfo[19]) > 0){

                    actualTDSPercentage = parseFloat(paymentInfo[19]);

                    if(actualSubTotal > 0){
                        tdsCharges = parseFloat((actualSubTotal * actualTDSPercentage) / 100);
                    }
                    if(acutalNetAmount > 0){
                        netTDSCharges = parseFloat((acutalNetAmount * actualTDSPercentage) / 100);
                    }
                    showtds = true;
                }
            }

            /* if(paymentInfo[16] !== undefined && paymentInfo[16] !== null){
                setPaymentMethod(paymentInfo[16]);
            } */

        }

        if(actualSubTotal > 0){
            if(gatewaycharges > 0){
                taxAmount = parseFloat(((actualSubTotal + gatewaycharges) * 18) / 100);
            }else{
                taxAmount = parseFloat((actualSubTotal * 18) / 100);
            }
        }

        if(acutalNetAmount > 0){
            if(netGateWayCharges > 0){
                netTaxAmount = parseFloat(((acutalNetAmount + netGateWayCharges) * 18) / 100);
            }else{
                netTaxAmount = parseFloat((acutalNetAmount * 18) / 100);
            }
        }

        //calc total amount.
        if(actualSubTotal > 0){
            totalAmount = ((actualSubTotal + taxAmount + gatewaycharges) - tdsCharges);
        }
        if(acutalNetAmount > 0){
            netTotalAmount = ((acutalNetAmount + netTaxAmount + netGateWayCharges) - netTDSCharges);
        }

        if(isAddonEnbled && addOnsRecordVal > 0){
            netTotalAmount = netTotalAmount - (addOnsRecordVal + (addOnsRecordVal / 100 * 18));
        }

        setTDS(tdsCharges);
        setGateWayCharges(gatewaycharges);
        setShowTDS(showtds);
        setShowGatewayCharges(showGwCharges);
        setTax(taxAmount);
        setTDSPercentage(actualTDSPercentage);

        setProrataDeduction(prorataDeductionAmount);
        setProRataCharges(prorataAmount);
        setTotal(totalAmount);
        setNetAmount(netTotalAmount);
        processPaymentType(netTotalAmount)
    }

    const processPaymentType = (netamount) => {
        if(subscriptionType === "Recurring"){
            if(showEmandate){
                paymentTypeHandle("", "emandate");
                setIsEMandate(true);
            }
        }else{
            setIsRecurringPayment(false);
        }
    }

    const getBillingInfo = async () => {

        const orgInfo = getOrganizationInfo();
        if(orgInfo && Object.keys(orgInfo).length > 0){
            let billingData = {
                Organization_Name : orgInfo[1] ? orgInfo[1] : "",
                Phone_No_2 : orgInfo[6] ? orgInfo[6] : "",
                Email : orgInfo[4] ? orgInfo[4] : "",
                Country : orgInfo[30] ? orgInfo[30] : "",
                State : orgInfo[29] ? orgInfo[29] : "",
                City : orgInfo[27] ? orgInfo[27] : "",
                PinZip_Code : orgInfo[28] ? orgInfo[28] : "",
                Street_1 : orgInfo[25] ? orgInfo[25] : "",
                Street_2 : orgInfo[26] ? orgInfo[26] : "",
                GST_IN : orgInfo[39] ? orgInfo[39] : "",
            };

            billingData["Country"] = "India";

            if(billingData.GST_IN !== ""){
                setShowGST(true);
            }

            setBillingInfo({...billingData});
        }
    }

    const getLicenseInfo = async () => {
        let params = {
            "ENTITY": "razorpay",
            "OPERATION" : 'licenseinfo'
        }
        let response = await requestApi.processServerRequest(params);

        if(response.issuccess){
            if(response.data){
                const data = response.data;
                setLiceinseInfo([...data]);
            }
        }else{
            handleErrorResponse(response.errormsg);
        }
    }

    const handleBackBtn = () => {
        setCurrentStep(currentStep - 1);
    }

    const handleProceed = () => {
        setSessionValue('licenseError','false');
        setSessionValue('licenseErrorMsg','');
        setSessionValue('licenseExpried','false');
        setSessionValue('licenseValidate',[]);
        setCurrentStep(currentStep + 1);
    }

    const handleInputChange = (e) => {
        if(e){
            const name = e.target.name;
            const value = e.target.value;

            if(name === "Phone_No_2"){
                const re = /^[0-9\b]+$/;
                if(value !== '' && !re.test(value)){
                    return;
                }
            }

            billingInfo[name] = value;
            setBillingInfo({...billingInfo});
        }
    }

    const handleRadioChange = (e, type) => {

        //remove GST content when disable gst checkbox.
        if(type === 'GST'){

            if(showGST){
                if(billingInfo.GST_IN){
                    billingInfo['GST_IN'] = "";
                    formError['GST_IN'] = "";
                }
            }
            setFormError(formError);
            setShowGST(!showGST);

        }else if(type === 'PaymentMethod'){
            if(e.target.name === "aadhaar"){
                showToast("Currently not supported", "top-right", "warning");
                return;
            }
            // default set netbanking
            setPaymentMethod(e.target.name);
            //setCreditCardPayment(!CreditCardPayment);
        }
    }

    const onFormSubmit = async (e) => {
        e.preventDefault();
        if(showGST){
            const re = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;
            const gstin = billingInfo?.GST_IN?.trim() || "";
            if (!gstin || !re.test(gstin)) {
                setFormError(prev => ({
                    ...prev,
                    GST_IN: "Please enter a valid GST number"
                }));
                scrollToGSTNOerror();
                return;
            } else{
                formError['GST_IN'] = "";
                setFormError({...formError});
            }
        }

        const params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "UPDATE_SUBSCRIPTION_BILLING",
            "FORMNAME": orgFormName,
            "FIELDS" : billingInfo
        };

        let response = await requestApi.processServerRequest(params,'WebV2','post');
        if(response.issuccess){
            if(response.data && response.data.length > 0){
                updateOrganizationInfo(response.data);
                await paymentHandler();
            }
        }else{
            handleErrorResponse(response.errormsg);
        }
    }

    const createEmandateAuth = async () => {
        let response = [];
        if(paymentMethod === "" || paymentMethod === "emandate"){
            showToast("Please choose any payment method", "top-right", "error");
            return;
        }
        const params = {
            "ENTITY": "razorpay",
            "OPERATION": "createEmandateAuth",
            "paymentmethod" : paymentMethod,
            "billingInfo" : billingInfo,
            "totalamount": total,
            "taxamount": tax,
            "tdsamount": TDS,
            "usagetype": usageType,
            "noofuser": requiredUsers,
            "isupdate": isEarlyUpdate ? 'yes' : 'no',
            "netamount": isEarlyUpdate ? netAmount : total,
            "rateperuser": isAddonEnbled ? parseFloat(pricePerUser) + (addOnsTotal / planMonths) : parseFloat(pricePerUser),
            "isAddonsEnabled" : isAddonEnbled,
            "addOnsRecord" : addOnsRecord,
            "addOnsCallRec" : callRec,
            "addOnsWhatsappApi" : whatsappApi,
            "addOnsCloudTele" : cloudTele
        };
        setShowLoader(true);
        let res = await requestApi.processServerRequest(params,'WebV2','post');
        setShowLoader(false);
        if(res.issuccess){
            response = res.data;
        }
        return response;
    }

    const paymentHandler = async (e) => {

        let orderInfo = [];
        let currentPaymentMethod = "";
        //just cancel current subscription and change payment mode to manual
        let isValid = validateToMakePaymentProcess();
        if(isValid['status'] !== undefined && isValid['status'] === false){
            showToast(isValid['error']);
            return;
        }
        let printlog = false;
        if(usageType === 7){
            await capturePayment([]);
            return;
        }
        setShowLoader(true);
        if(showEmandate && isEMandate){
            orderInfo = await createEmandateAuth();
            if(orderInfo[4] !== undefined){
                printlog = orderInfo[4];
            }
            if(usageType == 14){
                if(orderInfo.length === 0){
                    setCurrentStep(4);
                    //showToast("Payment Id " + orderInfo);
                    return;
                }
            }
            currentPaymentMethod = "Emandate";
        }else if(isRecurringPayment && showSubscription){
            orderInfo = await createSubscription();
            currentPaymentMethod = "Subscription";
        }else if(showOnline){
            orderInfo = await createOrder();
            currentPaymentMethod = "Online";
        }else{
            showToast("(#80012) Payment Gateway Currently Unavailable", "", "error");
            return;
        }

        setShowLoader(false);

        if(orderInfo.length > 0){

            const options = {
                name: "Cratio Payment",
                //image : "https://s3.ap-south-1.amazonaws.com/cratiocrm.com/images/razorpaylogo.png",
                handler: async (response) => {
                    if(printlog){
                        console.log(response)
                        console.log(response)
                        console.log(currentPaymentMethod)
                    }
                    try {
                        if(currentPaymentMethod === "Emandate"){
                            await captureEmandatePayment(response,orderInfo);
                        }else if(currentPaymentMethod === "Subscription"){
                            await captureSubscriptionPayment(response);
                        }else if(currentPaymentMethod === "Online"){
                            await capturePayment(response);
                        }else{
                            showToast("Payment method...", "", "error")
                        }
                    } catch (err) {
                        console.log(err);
                    }
                },
                prefill : {
                    "name" : billingInfo.Organization_Name ? billingInfo.Organization_Name : "",
                    "email" : billingInfo.Email ? billingInfo.Email : "",
                    "contact" : billingInfo.Phone_No_2 ? billingInfo.Phone_No_2 : "",
                     //"method":"card"//{card|netbanking|wallet|emi|upi}
                },
                theme: {
                    color: "#0066cc",
                },
                modal : {
                    ondismiss : function(response) {
                        //showToast(`Payment Cancelled...`,`top-right`,`warning`);
                    }
                },
                notes : {
                    "email" : billingInfo.Email,
                    "gst_number" : billingInfo.GST_IN,
                    "company_name" : billingInfo.Organization_Name,
                    "mobile_or_phone" : billingInfo.Phone_No_2
                }
            };
            let order_id = "";
            if(currentPaymentMethod === "Emandate"){
                options.customer_id = orderInfo[0];
                order_id = orderInfo[1];
                options.amount = 0;
                options.recurring = true;
                options.key = orderInfo[3];
                options.description = "Max Amount: ₹" + orderInfo[2] / 100 + "/-";
            }else if(currentPaymentMethod === "Subscription"){
                options.subscription_id = orderInfo[0];
                options.description = "Subscription ID: " + orderInfo[0];
                options.amount = orderInfo[1];
                options.prefill.method = CreditCardPayment ? "card" : "upi";
                options.key = orderInfo[2];
            }else if(currentPaymentMethod === "Online"){
                order_id = orderInfo[0];
                options.description = "Order ID: " + orderInfo[0];
                options.amount = orderInfo[1];
                options.key = orderInfo[2];
            }else{
                showToast("Something Went wrong...", "", "error")
            }
            options.order_id = order_id;
            options.notes.merchant_order_id = order_id;
            options.notes.payment_by = "green_theme";

            const rzp1 = new window.Razorpay(options);
            rzp1.open();
        }

    };

    const createOrder = async () => {

        let order = "";
        const params = {
            "ENTITY": "razorpay",
            "OPERATION": "createorder",
            "totalamount": total,
            "usagetype" : usageType
        };

        let response = await requestApi.processServerRequest(params,'WebV2','post');
        if(response.issuccess){
            order = response.data;
        }else{
            handleErrorResponse(response.errormsg);
        }

        return order;
    }

    const createSubscription = async () => {
        let subscription = "";
        const params = {
            "ENTITY": "razorpay",
            "OPERATION": "createSubscription",
            "totalamount": total,
            "netamount": isEarlyUpdate ? netAmount : total,
            "isupdate": isEarlyUpdate ? 'yes' : 'no',
            "usagetype" : usageType,
            "plan" : plan
        };

        let response = await requestApi.processServerRequest(params,'WebV2','post');

        if(response.issuccess){
            subscription = response.data;
        }else{
            handleErrorResponse(response.errormsg);
        }

        return subscription;
    }

    const capturePayment = async (res) => {

        const paymentId = res.razorpay_payment_id;
        const orderId = res.razorpay_order_id;
        const params = {
            "ENTITY": "razorpay",
            "OPERATION": "capturewppayment",
            "paymentid": paymentId,
            "orderid": paymentId,
            "netamount": subTotal,
            "taxamount": tax,
            "tdsamount": TDS,
            "totalamount": total,
            "noofuser": requiredUsers,
            "modeofpayment": plan,
            "rateperuser": isAddonEnbled ? parseFloat(pricePerUser) + (addOnsTotal / planMonths) : parseFloat(pricePerUser),
            "gatewaycharges": gatewayCharges,
            "isupdate": isEarlyUpdate ? `yes` : `no`,
            "usagetype" : usageType,
            "isAddonsEnabled" : isAddonEnbled,
            "addOnsRecord" : addOnsRecord,
            "addOnsCallRec" : callRec,
            "addOnsWhatsappApi" : whatsappApi,
            "addOnsCloudTele" : cloudTele
        };

        setShowLoader(true);
        let response = await requestApi.processServerRequest(params,'WebV2','post');
        setShowLoader(false);

        if(response.issuccess){
            handleProceed();
        }else{
            handleErrorResponse(response.errormsg);
        }
    }

    const captureSubscriptionPayment = async (res) => {

        const paymentId = res.razorpay_payment_id;
        const subscriptionId = res.razorpay_subscription_id;
        const params = {
            "ENTITY": "razorpay",
            "OPERATION": "captureSubscription",
            "paymentid": paymentId,
            "orderid": subscriptionId,
            "netamount": subTotal,
            "taxamount": tax,
            "tdsamount": TDS,
            "totalamount": total,
            "noofuser": requiredUsers,
            "modeofpayment": plan,
            "rateperuser": isAddonEnbled ? parseFloat(pricePerUser) + (addOnsTotal / planMonths) : parseFloat(pricePerUser),
            "gatewaycharges": gatewayCharges,
            "subscriptionid": subscriptionId,
            "isupdate": isEarlyUpdate ? 'yes' : 'no',
            "usagetype" : usageType,
            "isAddonsEnabled" : isAddonEnbled,
            "addOnsRecord" : addOnsRecord,
            "addOnsCallRec" : callRec,
            "addOnsWhatsappApi" : whatsappApi,
            "addOnsCloudTele" : cloudTele
        };

        setShowLoader(true);
        let response = await requestApi.processServerRequest(params,'WebV2','post');
        setShowLoader(false);
        if(response.issuccess){
            handleProceed();
        }else{
            handleErrorResponse(response.errormsg);
        }
    }


    const captureEmandatePayment = async (res, orderInfo) => {

        const paymentId = res.razorpay_payment_id;
        const orderid = res.razorpay_order_id;
        const max_amount = orderInfo[2] !== undefined ? orderInfo[2] : 0;
        let e_payments = paymentsMethods["emandate"];
        let isUpfrontAmount = false;
        for(let i = 0; i < e_payments.length; i++){
            let name = e_payments[i]["name"];
            if(name === paymentMethod){
                isUpfrontAmount = e_payments[i]["isUpfrontAmount"];
            }
        }
        const params = {
            "ENTITY": "razorpay",
            "OPERATION": "captureEmandatePayment",
            "paymentmethod": paymentMethod,
            "paymentid": paymentId,
            "orderid": orderid,
            "max_amount": max_amount,
            "netamount": subTotal,
            "taxamount": tax,
            "tdsamount": TDS,
            "totalamount": total,
            "noofuser": requiredUsers,
            "modeofpayment": plan,
            "billingInfo": billingInfo,
            "rateperuser": isAddonEnbled ? parseFloat(pricePerUser) + (addOnsTotal / planMonths) : parseFloat(pricePerUser),
            "gatewaycharges": gatewayCharges,
            "isupdate": isEarlyUpdate ? 'yes' : 'no',
            "usagetype" : usageType,
            "isAddonsEnabled" : isAddonEnbled,
            "addOnsRecord" : addOnsRecord,
            "addOnsCallRec" : callRec,
            "addOnsWhatsappApi" : whatsappApi,
            "addOnsCloudTele" : cloudTele,
            "isUpfrontAmount" : isUpfrontAmount
        };

        setShowLoader(true);
        let response = await requestApi.processServerRequest(params,'WebV2','post');
        setShowLoader(false);
        if(response.issuccess){
            handleProceed();
        }else{
            handleErrorResponse(response.errormsg);
        }
    }

    const scrollToGSTNOerror = () => {
		if(gstNoRef != null && gstNoRef.current != null){
			gstNoRef.current.scrollIntoView({ behavior: "smooth" });
		}
	};

    const paymentTypeHandle = (e, value) => {
        if(value === "emandate"){
            setIsEMandate(true);
            if(!paymentMethod){
            //if(paymentMethod !== "netbanking" && paymentMethod !== "debitcard" && paymentMethod !== "upi" && paymentMethod !== ""){
                setPaymentMethod(paymentsMethods["emandate"][0]['name']);
            }
        }else{
            setIsEMandate(false);
        }
        updateUsageType(total < maxSubAmount && subscriptionType !== "Non Recurring" && showSubscription);
    };

    /* const handleChange = (selectedValue, name) => {
        let label = selectedValue.label !== undefined && selectedValue.label !== null ? selectedValue.label : '';
        let value = selectedValue.value !== undefined && selectedValue.value !== null ? selectedValue.value : '';

        if(name === 'State'){

            let cityOptions = [];
            CitiesOptions.map((val) => {
                if(val['state_id'] === value){
                    cityOptions.push(val);
                }
                return <></>;
            });

            setRegion(selectedValue);
            setCity('');
            setCityOption(cityOptions);
            billingInfo['PinZip_Code'] = '';
            billingInfo['Street_1'] = '';
            billingInfo['Street_2'] = '';

        } else if (name === 'City'){

            setCity(selectedValue);
            billingInfo['PinZip_Code'] = '';
            billingInfo['Street_1'] = '';
            billingInfo['Street_2'] = '';

        }

        billingInfo[name] = label;

        setBillingInfo({...billingInfo});
    };    */

    const validateToMakePaymentProcess = () => {
        let response = [];
        response["status"] = true;
        response["error"] = "";

        return response;
    }

    let EmandateLabel = ''
    if(paymentMethod){
        if(paymentMethod == "upi"){
            EmandateLabel = "UPI";
        }else if(paymentMethod == "debitcard"){
            EmandateLabel = "Debit Card";
        }else if(paymentMethod == "netbanking"){
            EmandateLabel = "Net Banking";
        }else if(paymentMethod == "creditcard"){
            EmandateLabel = "Credit Card";
        }
    }
    
    let length = paymentsMethods["emandate"].length;
    return (
        <>
            <div className={`subscription-billing-container`}>
                <div className={`back-btn`} onClick={handleBackBtn}>
                    <i className={`left-arrow-btn`} />
                </div>
                <div className={`payment-info-container clearfix`}>
                    <div className={`plan-top`} >
                        {   usageType === 4 &&
                            <div className="alert alert-warning text-center pricing-error">
                                <span>{`By Proceeding, you authorize the payment. Subscription will be charged in the next billing cycle.`}</span>
                            </div>
                        }
                        {   showEmandate && isEMandate && usageType === 15 && maxAmount > 0 && false &&
                            <div className="alert alert-warning text-center pricing-error">
                                <span>{`Your e-mandate has reached the maximum amount of ${maxAmount}. Please click here to make a payment for a new e-mandate authorisation.`}</span>
                            </div>
                        }
                        {   showEmandate && isEMandate && usageType === 14 && false &&
                            <div className="alert alert-warning text-center pricing-error">
                                <span>{`Your e-mandate's maximum amount is ${maxAmount}. Click here to make a payment to add users.`}</span>
                            </div>
                        }
                    </div>
                    <form name={'billinginfo'} onSubmit={(e) =>{return onFormSubmit(e)}}>
                        <div className={`billing-info-container`}>
                            <div className={`billing-content`}>
                                <div className={cx('', {"hide" : !(subscriptionType === "Recurring" && isEMandate)})}>
                                    <ul className={'billing-details-wrapper'}>
                                        <div className="payment-method-diff">
                                            <div className={`clearfix mt-2`}>
                                                <span className={`gst-info amount-span`}>Pay with: </span>
                                                <span className={'flex-center-v'} onChange={(event => {handleRadioChange(event, 'PaymentMethod')})}>
                                                    {
                                                        Object.keys(paymentsMethods["emandate"]).length > 0 &&
                                                        paymentsMethods["emandate"].map((value, index) => {
                                                            const totalAmount = ((subTotal * 18) / 100) + subTotal;
                                                            let ishide = false;
                                                            let max_amount = value.max_amount;
                                                            if(value.name === "upi"){
                                                                ishide = totalAmount > max_amount;
                                                            }
                                                            if(ishide) return null;
                                                            
                                                            return (
                                                                <div key={value.name + index} className="d-inline-block ml-3">
                                                                    <input
                                                                        type="radio"
                                                                        className={cx(`ml-1 form-label`)}
                                                                        checked={paymentMethod === value.name}
                                                                        name={value.name}
                                                                        defaultChecked={index === 1} // Caution: this Logic might be flaky if mapped array order changes
                                                                    />
                                                                    <span className={cx('ml-1 fw-100')}>
                                                                        {value.label}
                                                                    </span>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                    </ul>
                                </div>
                                {subscriptionType === "Recurring" && (isRecurringPayment || isEMandate) && <div>
                                    <ul className={cx('billing-details-wrapper')}>
                                        <div className={cx("payment-method-diff hide", {"hide" : subscriptionType === "Non Recurring" || !isRecurringPayment})}>
                                            <div className={`clearfix mt-2`}>
                                                <span className={`gst-info amount-span`}>Pay with: </span>
                                                <span className={'flex-center-v'} onChange={(event => {handleRadioChange(event, 'PaymentMethod')})}>
                                                    <div className={cx( "hide",
                                                        {'hide' : paymentMethod === 'UPI'}
                                                    )}>
                                                        <input
                                                            type="radio"
                                                            className={cx('ml-1 form-label')}
                                                            checked={CreditCardPayment || paymentMethod === 'Credit Card'}
                                                            name="credit card"
                                                        />
                                                        <span className={cx('ml-1 fw-100')}>
                                                            Credit Card
                                                        </span>
                                                    </div>
                                                    <div className={cx(
                                                        {'hide' : paymentMethod === 'Credit Card'}
                                                    )}>
                                                    <input
                                                        type="radio"
                                                        className={cx('ml-1 form-label')}
                                                        checked={!CreditCardPayment || paymentMethod === 'UPI'}
                                                        name="upiid"
                                                    />
                                                    <span className={cx('ml-1 fw-100')}>
                                                        UPI
                                                    </span>
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                        <p className="payment-type-info">
                                            {`This is a recurring subscription. Your UPI or card will be charged automatically on each renewal date until you cancel..`}
                                        </p>
                                        <p className='payment-type-desc payment-type-info'>
                                            {`Tax invoices will be available in the Payments section after each successful payment. You can upgrade or cancel your subscription at any time.`}
                                        </p>
                                        <li className="payment-type-method">
                                            <span><img className={`razorpay-dark-img`} src={razorPayDarkTheme}></img></span>
                                        </li>
                                    </ul>
                                </div>}

                                <ul className={`billing-details-wrapper`}>
                                    <div className={`billing-title`}>Billing Details</div>
                                    <li className={`row mT10`}>
                                        <Col md={`6`}>
                                            <label className={'form-label'} htmlFor="automation_name">Billing Name/Company Name</label>
                                            <input
                                                name={`Organization_Name`}
                                                className={`form-control`}
                                                type={`text`}
                                                autoComplete={'off'}
                                                required={true}
                                                value={billingInfo.Organization_Name ? billingInfo.Organization_Name : ''}
                                                onChange={handleInputChange}
                                            />
                                        </Col>
                                        <Col md={`6`}>
                                            <label className={'form-label'} htmlFor="automation_name">Phone Number</label>
                                            <input
                                                name={`Phone_No_2`}
                                                className={`form-control`}
                                                type={`text`}
                                                autoComplete={'off'}
                                                required={true}
                                                value={billingInfo.Phone_No_2 ? billingInfo.Phone_No_2 : ''}
                                                onChange={handleInputChange}
                                            />
                                        </Col>
                                    </li>
                                    <li className={`row`}>
                                        <Col md={`6`}>
                                            <label className={'form-label'} htmlFor="automation_name">Street 1</label>
                                            <input
                                                name={`Street_1`}
                                                className={`form-control`}
                                                type={`text`}
                                                autoComplete={'off'}
                                                required={true}
                                                value={billingInfo.Street_1 ? billingInfo.Street_1 : ''}
                                                onChange={handleInputChange}
                                            />
                                        </Col>
                                        <Col md={`6`}>
                                            <label className={'form-label'} htmlFor="automation_name">Street 2</label>
                                            <input
                                                name={`Street_2`}
                                                className={`form-control`}
                                                type={`text`}
                                                autoComplete={'off'}
                                                required={true}
                                                value={billingInfo.Street_2 ? billingInfo.Street_2 : ''}
                                                onChange={handleInputChange}
                                            />
                                        </Col>
                                    </li>
                                    <li className={`row`}>
                                        <Col md={`6`}>
                                            <label className={'form-label'} htmlFor="automation_name">City</label>
                                            <input
                                                name={`City`}
                                                className={`form-control`}
                                                type={`text`}
                                                autoComplete={'off'}
                                                required={true}
                                                value={billingInfo.City ? billingInfo.City : ''}
                                                onChange={handleInputChange}
                                            />
                                        </Col>
                                        <Col md={`6`}>
                                            <label className={'form-label'} htmlFor="automation_name">Zip</label>
                                            <input
                                                name={`PinZip_Code`}
                                                className={`form-control`}
                                                type={`text`}
                                                autoComplete={'off'}
                                                required={true}
                                                value={billingInfo.PinZip_Code ? billingInfo.PinZip_Code : ''}
                                                onChange={handleInputChange}
                                            />
                                        </Col>
                                    </li>
                                    <li className={`row`}>
                                        <Col md={`6`}>
                                            <label className={'form-label'} htmlFor="automation_name">Country</label>
                                            <input
                                                name={`Country`}
                                                className={`form-control`}
                                                type={`text`}
                                                autoComplete={'off'}
                                                required={true}
                                                value={billingInfo.Country ? billingInfo.Country : ''}
                                                onChange={handleInputChange}
                                            />
                                        </Col>
                                        <Col md={`6`}>
                                            <label className={'form-label'} htmlFor="automation_name">State</label>
                                            <input
                                                name={`State`}
                                                className={`form-control`}
                                                type={`text`}
                                                autoComplete={'off'}
                                                required={true}
                                                value={billingInfo.State ? billingInfo.State : ''}
                                                onChange={handleInputChange}
                                            />
                                        </Col>
                                    </li>
                                    <li className="row">
                                        <Col md={`12`}>
                                            <label className={'form-label'} htmlFor="automation_name">Email</label>
                                            <input
                                                name={`Email`}
                                                className={`form-control`}
                                                type={`text`}
                                                autoComplete={'off'}
                                                required={true}
                                                value={billingInfo.Email ? billingInfo.Email : ''}
                                                onChange={handleInputChange}
                                            />
                                        </Col>
                                    </li>
                                    <li className={`row`}>
                                        <Col md={`12`}>
                                            <div className={`clearfix mt-2`}>
                                                <span className={`gst-info`}>Are you registered for GSTIN?</span>
                                                <span className={'flex-center-v'} onChange={(event => {handleRadioChange(event, 'GST')})}>
                                                    <input type="radio" className={'form-label'} checked={showGST} name="gstenabled" /> <span className={'ml-1 fw-100'}>Yes</span>
                                                    <input type="radio" className={'ml-1 form-label'} checked={!showGST} name="gstdisabled" /> <span className={'ml-1 fw-100'}>No</span>
                                                </span>
                                            </div>
                                            <div className={cx(`col-md-6 mt-3`,{
                                                'hide' : !showGST
                                            })}
                                            ref={gstNoRef}>
                                                <input
                                                    name={`GST_IN`}
                                                    className={`form-control subscription-gst-text`}
                                                    type={`text`}
                                                    autoComplete={'off'}
                                                    required={showGST}
                                                    value={billingInfo.GST_IN ? billingInfo.GST_IN : ''}
                                                    onChange={handleInputChange}
                                                    placeholder={`GSTIN`}
                                                />
                                                {formError.GST_IN && formError.GST_IN !== "" && <em className={`error invalid-feedback`}>{formError.GST_IN}</em>}
                                                <div className="subscription-gst-text">To receive an updated invoice including your GST details, kindly provide your GST Tax ID.</div>
                                            </div>
                                        </Col>
                                    </li>
                                </ul>
                                <div className={`b-clear`} />
                            </div>

                            <div className={`billing-summary-container`}>
                                <div className={`summary-content`}>
                                    <div className={`title`}>{`Summary`}</div>
                                    <div className={`summary-plan-info`}>
                                        <div className={`subtotal-info line-item`}>
                                            <span>{`Subtotal`}</span>
                                            <span className={`amount`}>
                                                <span className={`sub-amount`}>
                                                    {subTotal && usageType !== 7 ? currencyFormatter('en-IN', 'INR', subTotal,2) : currencyFormatter('en-IN', 'INR', 0,2)}
                                                </span>
                                            </span>
                                        </div>
                                        {
                                            prevPaymentDeduction > 0 &&

                                            <div className={`subtotal-info line-item`}>
                                                <span>{`Previous Payment Deduction`}</span>
                                                <span className={`amount`}>
                                                    <span className={`sub-amount`}>
                                                        {"-" + (prevPaymentDeduction ? currencyFormatter('en-IN', 'INR', prevPaymentDeduction,2) : currencyFormatter('en-IN', 'INR', 0,2))}
                                                    </span>
                                                </span>
                                            </div>
                                        }
                                        {prorataDeduction > 0 ?
                                            isEarlyUpdate && proRataCharges > 0 &&
                                            <div className={`subtotal-info line-item`}>
                                                <span>{`Prorata Charges`}</span>
                                                <span className={`amount`}>
                                                    <span className={`sub-amount`}>
                                                        {"-" + (prorataDeduction ? currencyFormatter('en-IN', 'INR', prorataDeduction, 2) : currencyFormatter('en-IN', 'INR', 0,2))}
                                                    </span>
                                                </span>
                                            </div>
                                            :
                                            isEarlyUpdate && proRataCharges > 0 &&
                                            <div className={`subtotal-info line-item`}>
                                                <span>{`Prorata Charges`}</span>
                                                <span className={`amount`}>
                                                    <span className={`sub-amount`}>
                                                        {(prorataDeduction ? currencyFormatter('en-IN', 'INR', prorataDeduction * -1, 2) : currencyFormatter('en-IN', 'INR', 0,2))}
                                                    </span>
                                                </span>
                                            </div>
                                        }
                                        {
                                            prevPaymentDeduction > 0 &&

                                            <div className={`subtotal-info line-item net-amount mt-1`}>
                                                <span>{`Net Amount`}</span>
                                                <span className={`amount`}>
                                            <span className={`sub-amount`}>
                                                {(currencyFormatter('en-IN', 'INR', subTotal - prevPaymentDeduction - prorataDeduction,2))}
                                            </span>
                                        </span>
                                            </div>
                                        }

                                        <div className={`subtotal-info line-item`}>
                                            <span>{`Tax (18%)`}</span>
                                            <span className={`amount`}>
                                                <span className={`sub-amount`}>
                                                    {tax ? currencyFormatter('en-IN', 'INR', tax,2) : currencyFormatter('en-IN', 'INR', 0,2)}
                                                </span>
                                            </span>
                                        </div>
                                        <div className={cx(`subtotal-info line-item`,{
                                            'hide' : !showGatewayCharges
                                        })}>
                                            <span>{`Gateway Charges (1.95%)`}</span>
                                            <span className={`amount`}>
                                                <span className={`sub-amount`}>
                                                    {gatewayCharges ? currencyFormatter('en-IN', 'INR', gatewayCharges,2) : currencyFormatter('en-IN', 'INR', 0,2)}
                                                </span>
                                            </span>
                                        </div>
                                        <div className={cx(`subtotal-info line-item`,{
                                            'hide' : !showTDS
                                        })}>
                                            <span>{`TDS (${tdsPercentage}%)`}</span>
                                            <span className={`amount`}>
                                            <span className={`sub-amount`}>
                                                {TDS ? currencyFormatter('en-IN', 'INR', TDS,2) : currencyFormatter('en-IN', 'INR', 0,2)}
                                            </span>
                                        </span>
                                        </div>
                                    </div>
                                    <div className={`total-amount-info`}>
                                        <span>{`Total Amount`}</span>
                                        <span className={`amount`}>
                                        <span>
                                            {total ? currencyFormatter('en-IN', 'INR', total,2) : currencyFormatter('en-IN', 'INR', 0,2)}
                                        </span>
                                    </span>
                                    </div>
                                    <button className={cx(`confirm-order-btn`, {"hide" : !(total > 0)})} type={`submit`}>{`MAKE PAYMENT`}</button>
                                    <span className={cx({'hide' : !(subTotal > 0) || !(total > 0)})}>By proceeding, you agree to our <a href='https://cratiocrm.com/terms-of-service/' class="footerlink" target="_blank">terms of use</a></span>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default SubscriptionBilling;
